import React from 'react';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetchDelete, openApiFetchGet } from '../../../store/openApiFetch';
import { IconEditButton } from '../../common/iconButtons/IconEditButton';
import { IconRemoveButton } from '../../common/iconButtons/IconRemoveButton';
import {
    Content,
    Panel,
    PanelBody,
    PanelRouterLink,
    Table,
    TableBody,
    TableButtons,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    Topbar,
    TopbarCrumb,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../../elements';
import { Spinner } from '../../spinners';
import { useReactAsync } from '../../utils/useReactAsync';

async function loadFields({ equipmentTypeId }: { equipmentTypeId: string }) {
    const result = await openApiFetchGet('/api/equipmentTypes/{equipmentTypeId}/fields', { equipmentTypeId });
    return result;
}

export function EquipmentTypeFieldList(props: { params: { equipmentTypeId: string } }) {
    const { equipmentTypeId } = props.params;
    const translate = useTranslate();
    const { data, reload, isLoading } = useReactAsync(loadFields, { equipmentTypeId }, [equipmentTypeId]);
    const navigate = useNavigate();

    async function removeField(equipmentTypeFieldId: string) {
        await openApiFetchDelete('/api/equipmentTypes/{equipmentTypeId}/fields/{equipmentTypeFieldId}', {
            equipmentTypeId,
            equipmentTypeFieldId,
        });
        await reload();
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title={translate('equipment.customFields')} icon="fa-cogs" />
                    <TopbarCrumb>
                        <Link to="/settings/equipmenttypes">{translate('equipment.types')}</Link>
                    </TopbarCrumb>
                </TopbarLeft>
                <TopbarRight>
                    <PanelRouterLink
                        to={`/settings/equipmenttypes/${equipmentTypeId}/fields/add`}
                        text={translate('equipment.addField')}
                        icon="fa fa-plus"
                        small={true}
                    />
                </TopbarRight>
            </Topbar>

            <Content>
                <Tray>
                    <Panel>
                        {(isLoading && <Spinner />) || (
                            <PanelBody noPadding={true}>
                                <Table>
                                    <TableHead>
                                        <TableHeadRow light={true}>
                                            <TableHeader>{translate('equipment.fieldName')}</TableHeader>
                                            <TableHeader>{translate('equipment.fieldOrder')}</TableHeader>
                                            <TableHeader>&nbsp;</TableHeader>
                                        </TableHeadRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.items &&
                                            data.items.map((item) => (
                                                <TableRow key={item.id}>
                                                    <TableData>{item.name}</TableData>
                                                    <TableData>{item.fieldOrder}</TableData>
                                                    <TableButtons large>
                                                        <IconEditButton
                                                            onClick={() =>
                                                                navigate(`/settings/equipmenttypes/${equipmentTypeId}/fields/${item.id}/edit`)
                                                            }
                                                        />
                                                        <IconRemoveButton
                                                            removeQuestion={translate('common.confirmDelete', item.name)}
                                                            onClick={async () => removeField(item.id)}
                                                        />
                                                    </TableButtons>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </PanelBody>
                        )}
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
